import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldLabelComponent as LibFieldLabelComponent } from 'nebula-ui-kit';

/**
 * Delega en `lib-field-label` de nebula-ui-kit: texto, asterisco de obligatorio (`required`),
 * tooltip e icono de ayuda. Mantiene el selector `app-field-label` en plantillas de Vault.
 */
@Component({
  selector: 'app-field-label',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LibFieldLabelComponent],
  host: { class: 'app-field-label' },
  template: `
    <lib-field-label
      [label]="label()"
      [required]="required()"
      [tooltip]="tooltip()"
      [size]="size()"
    />
  `,
})
export class FieldLabelComponent {
  readonly label = input('', { alias: 'label' });
  readonly required = input(false, { alias: 'required' });
  readonly tooltip = input('', { alias: 'tooltip' });
  /** Mismo valor por defecto que `FieldLabelComponent` del kit (icono de información). */
  readonly size = input(12, { alias: 'size' });
}
